import useInvestmentProfile from 'hooks/requests/kyc/useInvestmentProfile';
import ProfileEditableTable from 'pages/profile/components/ProfileTabContent/components/ProfileEditableTable';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import classes from './index.module.scss';
import { getInvestmentProfileData } from './utils';

const InvestmentProfile = () => {
  const { investmentProfile } = useInvestmentProfile();

  return (
    <ProfileSection
      title={'Investment Profile'}
      titlesClassName={classes.title}
    >
      <ProfileEditableTable
        data={getInvestmentProfileData(investmentProfile)}
      />
    </ProfileSection>
  );
};

export default InvestmentProfile;
